module.exports = __webpack_public_path__ + "static/media/footer_top.79c29795.svg";